export const APPLICATION_BASE_PATH = '/application';
export const APPLICATION_DOWNLOAD_PATH = '/download';
export const PRUFORCE_PATH = '/pruforce';

export enum DownloadPagePermissionType {
  TEMP_READ = "READ_AGENT-PORTAL_DOWNLOAD"
}
